import '../styles/generic.css';

import { _ } from '../utils/l10n';
import { BaseButtonLink, ButtonLink } from './generic/ButtonLink';
import { BaseDetailSummaryItemProps, DetailSummaryItemInfo } from './DetailSummaryItemInfo';
import { Button } from './generic/Button';
import { ButtonSize } from '../types';
import { ComingSoonTag } from './solutions/ComingSoonTag';
import { ButtonSizes } from '../consts/button';

export interface DetailSummaryItemProps extends BaseDetailSummaryItemProps {
  /**
   * Button data
   */
  button?: {
    label: string;
    size?: ButtonSize;
  };
  /**
   * Action to be performed on button click
   */
  onClick?: () => void;
  /**
   * Button link data
   */
  link?: BaseButtonLink;
}

export const DetailSummaryItem = ({ title, description, button, onClick, link, longDesc }: DetailSummaryItemProps) => {
  const getAction = () => {
    if (button) {
      const buttonLink = link ? (
        <ButtonLink
          label={button.label}
          href={link.href}
          size={button.size || ButtonSizes.LARGE}
        />
      ) : null;

      return !!onClick ? (
        <Button
          label={button.label}
          onClick={onClick}
          size={button.size || ButtonSizes.LARGE}
        />
      ) : (
        buttonLink
      );
    }

    return null;
  };

  return (
    <div className="detail-summary-item">
      <DetailSummaryItemInfo
        title={title}
        description={description}
        longDesc={longDesc}
      />
      {button ? getAction() : <ComingSoonTag />}
    </div>
  );
};
